import { Tab, TabValue } from "./types.ts";

export const tabs: Tab[] = [
  {
    value: TabValue.Autogroup,
    label: "Autogroup",
  },
  {
    value: TabValue.AddInvoice,
    label: "Add Invoice",
  },
];
